/**
 * The composer's model and reasoning effort, remembered in this browser (ADMIN-212). The effort
 * is kept across model switches; the picker resolves it against the levels each model offers.
 */

const MODEL_KEY = "kourai-ai-model";
const EFFORT_KEY = "kourai-ai-effort";
const DEFAULT_MODEL = "deepseek-v4-flash";
const DEFAULT_EFFORT = "medium";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage can be unavailable (private mode); the choice still holds for this page.
  }
}

export const getSavedModel = () => read(MODEL_KEY) ?? DEFAULT_MODEL;
export const saveModel = (id: string) => write(MODEL_KEY, id);
export const getSavedEffort = () => read(EFFORT_KEY) ?? DEFAULT_EFFORT;
export const saveEffort = (id: string) => write(EFFORT_KEY, id);
